import React from "react";
import { Link } from "react-router-dom";
import PostAuthor from "./PostAuthor";
import { FALLBACK_THUMB, fallbackTo, readTime, stripHtml, uploadUrl } from "../constants";

const PostItem = ({ postID, category, title, description, authorID, thumbnail, createdAt, index }) => (
  <article className="post-card reveal" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
    <Link to={`/posts/${postID}`} className="post-card__media" tabIndex={-1}>
      <img src={uploadUrl(thumbnail)} alt="" loading="lazy" onError={fallbackTo(FALLBACK_THUMB)} />
    </Link>
    <div className="post-card__body">
      <div className="post-card__meta">
        <Link className="chip" to={`/posts/categories/${category}`}>
          {category}
        </Link>
        <span className="post-card__num num">{String(index + 1).padStart(2, "0")}</span>
      </div>
      <h3 className="post-card__title">
        <Link to={`/posts/${postID}`}>{title}</Link>
      </h3>
      <p className="post-card__excerpt">{stripHtml(description)}</p>
      <div className="post-card__footer">
        <PostAuthor authorID={authorID} createdAt={createdAt} />
        <span className="post-card__read">{readTime(description)}</span>
      </div>
    </div>
  </article>
);

export default PostItem;
